const noop = () => undefined;

export const createNoopSocket = () => ({
  on: noop,
  off: noop,
  emit: noop,
  connect: noop,
  disconnect: noop,
  connected: false,
});

const noopSocket = createNoopSocket();

export default noopSocket;
